import { put, select, takeLatest } from 'redux-saga/effects'
import { addToActivityLog } from '../../../timeline/store/timeline.actions'
import { TimelineConstants } from '../../../timeline/store/timeline.constants'
import { IItem } from '../../../timeline/store/timeline.types'
import { getCardiacArrestSelector } from '../selectors'
import { CardiacArrestConstants } from '../store/cardiacArrest.constants'

export function* addDefibProcedureToActivityLog() {
  const cardiacArrest = yield select(getCardiacArrestSelector)
  const newProcedure: IItem = {
    avatarPosition: 'start',
    itemType: 'Procedures',
    labelHeader: 'Defib 200 J',
    subHeader: 'Defibrillation shock of 200 joules given to patient.',
    paragraph: `${new Date(cardiacArrest.defibButtonSavedTime).toTimeString().split(' ')[0]}`,
    rowActionType: TimelineConstants.NOT_IMPLEMENTED,
    date: new Date(),
  }
  yield put(addToActivityLog(newProcedure))
}

export function* addDefibProcedureToActivityLogSaga() {
  yield takeLatest([CardiacArrestConstants.UPDATE_DEFIB], addDefibProcedureToActivityLog)
}
